<template>
  <div class="not-found">
    404
    <p>not found</p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: '404',
};
</script>

<style lang="less" scoped>
  .not-found {
    font-size: 80px;
    padding: 70px 0;
    text-align: center;
    font-weight: bold;
    p {
      margin-top: 20px;
      font-size: 20px;
    }
  }
</style>
